import axios from 'axios';

const getShowingDefaultSettings = async () => {
  const { data: settings } = await axios.get('/user_appointment_config');
  return settings;
};

export default getShowingDefaultSettings;
